<template>
  <v-card outlined>
    <HeaderPanel
      :header-text="title"
      >
    </HeaderPanel>
    <v-card-text class="pb-0">
      <v-container class="py-0">
        <v-row>
          <v-col class="pa-0" cols="12">
            <label for="username">Email</label>
            <v-text-field class="mb-4" hide-details="auto" dense id="x" v-model="user.username" outlined required></v-text-field>
            <label for="md_fullname">Full name</label>
            <v-text-field class="mb-4" hide-details="auto" dense id="md_fullname" v-model="user.md_fullname" outlined ="off" required></v-text-field>
            <label for="password">Password</label>
            <v-text-field class="mb-4" hide-details="auto" dense id="y" v-model="user.password" :type="'password'" outlined  autocomplete="off" required></v-text-field>

            <v-checkbox hide-details="auto" dense v-model="user.md_admin" label="Admin" :false-value="false" :true-value="true"></v-checkbox>
            <v-checkbox hide-details="auto" dense v-model="user.md_build" label="Build" :false-value="false" :true-value="true"></v-checkbox>
            <v-checkbox class="mb-4" v-model="user.email" hide-details="auto" dense label="Send welcome email" :value="true"></v-checkbox>

            <label for="clients">Clients</label> {{ user.md_clients }} {{ clients }}
            <vue-select
              id="clients"
              v-model="user.md_clients"
              class="mb-4"
              multiple
              :options="clients"
              label="name"
              ref="select"
              :reduce="item => item.ID"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </vue-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="pa-6">
      <v-spacer></v-spacer>
      <v-btn outlined :ripple="false" @click="toggleDialog()">Cancel</v-btn>
      <v-btn color="primary" :ripple="false" @click="save()">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: "UserForm",
  props: {
    title: {
      type: String,
      required: true,
    },
    userData: {
      type: Object,
      required: false,
    },
    clients: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
  },
  data() {
    return {
      user: {},
      packages: ["full", "pro", "basic"],
    }
  },
  mounted() {
    Object.assign(this.user, this.userData);
    this.user.email = this.mode === 'new' ? true : false;
    if(this.user.md_admin === "true") {
      this.user.md_admin = true
    } else {
      this.user.md_admin = false
    }
    if(this.user.md_build === "true") {
      this.user.md_build = true
    } else {
      this.user.md_build = false
    }
  },
  methods: {
    save() {
      //TODO - this is causing issues now as email has been removed for the userform
      //refactor when backend changes made
      this.user.md_clients.forEach(function(value){
        if (value == null || value == "") {
          value = "*";
        }
      })
      if(this.user.md_admin) { this.user.md_admin = "true" }
      else { this.user.md_admin = "false" }
      if(this.user.md_build) { this.user.md_build = "true" }
      else { this.user.md_build = "false" }
      this.user.md_email = this.user.username
      this.$store.dispatch("saveUser", this.user);
      this.toggleDialog();
    },
    toggleDialog() {
      this.$emit("toggleDialog", false);
    },
  },
};
</script>
